module.exports = __webpack_public_path__ + "img/icon-activity-foreman-header.265bd55e.jpg";